import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';

@Injectable({
    providedIn: 'root'
})
export class UserManagementService {
    api: string;

    constructor(private http: HttpClient) {
        this.api = environment.customerApiUrl;
    }

    getUserManagement(): Observable<any> {
        return this.http.get(`${this.api}/customer/get-client-management-data`);
    }

    updateUserManagement(param: any): Observable<any> {
        return this.http.post(`${this.api}/customer/update-dual-authorization-client-role`, param, {
            headers: {
                useLocalHandleException: 'Y'
            }
        });
    }
}
